import api from "../helpers/interceptor";

// ---------Reviews list ---------
export const ReviewsListing = async (payload) =>
  await api.get(
    `/reviewManagement/getReviewsList?page=${payload.page}&limit=${payload.limit}&search_key=${payload.search_key}`
  );

//   status
export const ReviewStatus = async (payload) =>
  await api.put(`/reviewManagement/updateReviewStatus`, payload);
// view detail api
export const ViewReviewsDetail = async (review_id) => {
  return await api.get(
    `/reviewManagement/getReviewDetails?review_id=${review_id}`
  );
};
